import { RGPD_VENDOR_ID_GA, RGPD_VENDOR_ID_SENTRY, RGPD_VENDORS_ID } from '../utils/constants';
import LCEvent from '../utils/customEvents';
import { sendMessageToNativeApp, WebViewChannel } from '../utils/webview';

export const isSentryAllowed = (didomi: any): boolean => {
    return didomi.getUserConsentStatusForVendor(RGPD_VENDOR_ID_SENTRY);
};
export const isFirebaseAllowed = (didomi: any): boolean => {
    return didomi.getUserConsentStatusForVendor(RGPD_VENDOR_ID_GA);
};

export const showPreferences = (): void => {
    if (window.Didomi) {
        window.Didomi.preferences.show();
    } else {
        console.error('Didomi SDK is not loaded yet.');
    }
};

export const resetPreferences = (): void => {
    if (window.Didomi) {
        window.Didomi.reset();
    } else {
        console.error('Didomi SDK is not loaded yet.');
    }
};

export const debugDidomi = (didomi): void => {
    if (didomi) {
        console.log({ didomi });
        console.log('Is the consent required ? : ', didomi.isConsentRequired());

        const partnerIdArray = RGPD_VENDORS_ID;
        partnerIdArray.forEach((id) => {
            console.log(
                `Consent for the vendor: ${id} ${didomi.getUserConsentStatusForVendor(
                    id,
                )} and cookies ${didomi.getUserConsentStatus('cookies', id)}`,
            );
        });
    }
};

export const sendDidomiEvent = (didomi): void => {
    if (didomi) {
        window.dispatchEvent(new CustomEvent(LCEvent.RGPD_READY, { detail: { didomi } }));
        sendMessageToNativeApp(WebViewChannel.RGPD, {
            firebase: isFirebaseAllowed(didomi),
        });
        // debugDidomi(didomi);
    }
};
